const shaka = require("shaka-player/dist/shaka-player.ui")
export class CaptionButton extends shaka.ui.Element {
  constructor(parent: any, controls: any, player: any) {
    super(parent, controls)
    // The actual button that will be displayed
    this.button_ = document.createElement("button")
    player.setTextTrackVisibility(false)
    this.button_.classList.add("shaka-caption-button")
    this.button_.classList.add("material-icons")
    this.button_.classList.add("shaka-caption-off")
    this.button_.setAttribute("aria-label", "activate captions")
    this.button_.textContent = "closed_caption"
    this.parent.appendChild(this.button_)
  }
}
export default function addCaptionButton(player: any, shakaComp: any) {
  CaptionButton.Factory = class {
    create(rootElement: any, controls: any) {
      return new CaptionButton(rootElement, controls, player)
    }
  }

  // Register our factory with the controls, so controls can create button instances.
  shakaComp.ui.Controls.registerElement("captions", new CaptionButton.Factory())
}
